<template>
<!-- +++++++++++++++++++++++ BEGIN customer type thuis  ++++++++++++++++++++++++++++++ -->
  <div v-if="State.Zoekgegevens.cust_type==='thuis'" class="block form">
    <h1 class="title form__title">Jouw gegevens</h1>
    <h2 class="form__subtitle">Persoonsgegevens</h2>

    <p class="form__input-title">Geslacht</p>
    <ValidationProvider tag="div"  rules="required" v-slot="{ errors }">
      <div class="form__radio-group" v-bind:class="{ invalid: errors.length != 0, 'form__radio-group-invalid': errors.length != 0 }"   >
        <div class="form__radio-button">
          <input
            type="radio"
            id="man"
            name="gender"
            value="man"
            v-model="State.Klantengegevens.Persoonsgegevens.Geslacht"
          />
          <span></span>
          <label class="form__radio-button-label" for="man">man</label>
        </div>
        <div class="form__radio-button">
          <input
            type="radio"
            id="vrouw"
            name="gender"
            value="vrouw"
            v-model="State.Klantengegevens.Persoonsgegevens.Geslacht"
          />
          <span></span>
          <label class="form__radio-button-label" for="vrouw">vrouw</label>
        </div>
        <div class="form__radio-button">
          <input
            type="radio"
            id="neutraal"
            name="gender"
            value="neutraal"
            v-model="State.Klantengegevens.Persoonsgegevens.Geslacht"
          />
          <span></span>
          <label class="form__radio-button-label" for="neutraal">neutraal</label>
        </div>
      </div>
      <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>
    <div class="form__row">
      <text-field
        input-id="voorletters"
        label="Voorletters"
        placeholder="A.B."
        rules="required"
        v-model="State.Klantengegevens.Persoonsgegevens.Voorletters"
      />

      <text-field
        input-id="tussenvoegsel"
        label="Tussenvoegsel"
        placeholder="van"
        v-model="State.Klantengegevens.Persoonsgegevens.Tussenvoegsel"
      />
    </div>

    <div class="form__row">
      <text-field
        input-id="achternaam"
        label="Achternaam"
        placeholder="Achternaam"
        rules="required"
        v-model="State.Klantengegevens.Persoonsgegevens.Achternaam"
      />
    </div>

    <div class="form__row">
      <ValidationProvider tag="div" class="form__date-field" rules="required" v-slot="{ errors }">
        <label for="geboortedatum">Geboortedatum</label>
        <input
          :class="{ invalid: errors.length != 0 }"
          type="date"
          id="geboortedatum"
          v-model="State.Klantengegevens.Persoonsgegevens.Geboortedatum"
        />
        <span class="error">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <h2 class="form__subtitle">Adresgegevens</h2>

    <div class="form__row">
      <text-field
        input-id="adres"
        label="Adres"
        placeholder="Dorpstraat"
        :value="State.street"
        rules="required"
        v-model="State.Klantengegevens.Adresgegevens.Adres"
      />
      <text-field
          input-id="huisnr"
          label="Huisnr"
          placeholder="1"
          :value="State.houseno"
          rules="required"
          v-model="State.Klantengegevens.Adresgegevens.Huisnr"
      />
      <text-field
          input-id="huisnr_toev"
          label="Huisnr_toev"
          placeholder="A"
          :value="State.houseno_ext"
          rules=""
          v-model="State.Klantengegevens.Adresgegevens.Huisnr_toev"
      />
    </div>

    <div class="form__row">
      <text-field
        input-id="postcode"
        label="Postcode"
        placeholder="0000 XX"
        :value="State.zipcode"
        rules="required|zipcode"
        v-model="State.Klantengegevens.Adresgegevens.Postcode"
      />
      <text-field
        input-id="plaats"
        label="Plaats"
        placeholder="Dalfsen"
        :value="State.city"
        rules="required"
        v-model="State.Klantengegevens.Adresgegevens.Plaats"
      />
    </div>
    <h2 class="form__subtitle">Contactgegevens</h2>

    <div class="form__row">
      <text-field
        input-id="mobiel-nummer"
        class="form__text-field--60-width"
        label="Mobiel telefoonnummer"
        placeholder="0612345678"
        rules="required|mobilephone"
        v-model="State.Klantengegevens.Contactgegevens.MobielTelefoonnummer"
      />
    </div>
    <div class="form__row">
      <text-field
        input-id="vast-nummer"
        class="form__text-field--60-width"
        label="Vast telefoonnummer (indien nummerbehoud gewenst)"
        placeholder="0529123456"
        rules="phone"
        v-model="State.Klantengegevens.Contactgegevens.VastTelefoonnummer"
      />
    </div>
    <div class="form__row">
      <text-field
        input-id="email"
        label="E-mailadres"
        placeholder="voorbeeld@mail.nl"
        rules="required|email"
        v-model="State.Klantengegevens.Contactgegevens.Emailadres"
      />
    </div>
    <div v-if="providerEmailAdress === true" class="form__row">
      <text-field
        input-id="plinq-email"
        class="form__text-field--60-width"
        :label="'(Indien gewenst) Mijn '+companyName+' e-mailadres'"
        v-model="State.Klantengegevens.Contactgegevens.PLINQEmailadres"
      >
        <template v-slot:afterInput>
          <p class="form__text-field-details">@{{companyCustomerEmail}}</p>
        </template>
      </text-field>
    </div>

    <h2 class="form__subtitle">Betaalgegevens</h2>
    <p class="form__description">Je betaalt je abonnement maandelijks via automatisch incasso.</p>
    <div class="form__row">
      <text-field
        input-id="rekeningnummer"
        label="IBAN-rekeningnummer"
        placeholder="NL00BANK0123456789"
        rules="required|iban"
        v-model="State.Klantengegevens.Betaalgegevens.Rekeningnummer"
      />
    </div>

    <div class="form__row">
      <text-field
        input-id="achternaam"
        label="Naam rekeninghouder"
        placeholder="Achternaam"
        v-model="State.Klantengegevens.Betaalgegevens.NaamRekeninghouder"
        rules="required"
      />
      <text-field
        input-id="woonplaats"
        label="Woonplaats rekeninghouder"
        placeholder="Plaats"
        rules="required"
        v-model="State.Klantengegevens.Betaalgegevens.WoonplaatsRekeninghouder"
      />
    </div>

    <div v-if="neighboursActionEnabled == 1 ">
      <h2 class="form__subtitle">Vrienden- en Burenactie</h2>
      <ul>
        <li>Beide ontvangen 3 maanden lang €15 korting.</li>
        <li>Beide deelnemers moeten in Assendorp wonen.</li>
        <li>Minimaal één van de twee heeft nog geen abonnement bij Glasvezel Assendorp.</li>
        <li>Je kunt zo vaak meedoen als je wilt, zolang je voor elke deelname een nieuwe deelnemer aanbrengt.</li>
      </ul>

      <div class="form__row">
        <text-field
            input-id="burenactie_postcode"
            label="Postcode"
            placeholder="1111aa"
            v-model="State.Klantengegevens.Burenactie.Postcode"
            rules=""
        />
        <text-field
            input-id="burenactie_huisnr"
            label="Huisnummer"
            placeholder="1"
            rules=""
            v-model="State.Klantengegevens.Burenactie.Huisnr"
        />
        <text-field
            input-id="burenactie_huisnr"
            label="Toevoeging"
            placeholder="A"
            rules=""
            v-model="State.Klantengegevens.Burenactie.Huisnr_toev"
        />
      </div>
    </div>

    <h2 class="form__subtitle">Overige</h2>

    <custom-textarea
      row
      id="opmerkingen"
      label="Eventuele opmerkingen"
      v-model="State.Klantengegevens.Overig.Opmerking"
    />

    <checkbox row id="voorwaarden" v-model="State.Klantengegevens.Overig.AlgemeneVoorwaarden" rules="is_true">
      Ik ga akkoord met de <a :href="termsUrl" target="_blank">algemene voorwaarden</a> van {{ companyName }} BV.
    </checkbox>
  </div>

<!-- +++++++++++++++++++++++ END customer type thuis  ++++++++++++++++++++++++++++++ -->

  <!-- +++++++++++++++++++++++ BEGIN customer type zakelijk  ++++++++++++++++++++++++++++++ -->

  <div v-else class="block form">

    <h2 class="form__subtitle">Bedrijfsgegevens</h2>

    <div class="form__row">
      <text-field
          input-id="bedrijfsnaam"
          label="Bedrijfsnaam"
          placeholder="Bedrijfsnaam"
          rules="required"
          v-model="State.Klantengegevens.Bedrijfsgegevens.Bedrijfsnaam"
      />
    </div>

    <div class="form__row">
      <text-field
          input-id="kvknummer"
          label="KVK nummer"
          placeholder="KVK nummer"
          rules="required"
          v-model="State.Klantengegevens.Bedrijfsgegevens.KvkNummer"
      />
    </div>

    <h2 class="form__subtitle">Contactpersoon</h2>

    <p class="form__input-title">Geslacht</p>
    <ValidationProvider tag="div"  rules="required" v-slot="{ errors }">
      <div class="form__radio-group" v-bind:class="{ invalid: errors.length != 0, 'form__radio-group-invalid': errors.length != 0 }"   >
        <div class="form__radio-button">
          <input
              type="radio"
              id="man"
              name="gender"
              value="man"
              v-model="State.Klantengegevens.Contactpersoon.Geslacht"
          />
          <span></span>
          <label class="form__radio-button-label" for="man">man</label>
        </div>
        <div class="form__radio-button">
          <input
              type="radio"
              id="vrouw"
              name="gender"
              value="vrouw"
              v-model="State.Klantengegevens.Contactpersoon.Geslacht"
          />
          <span></span>
          <label class="form__radio-button-label" for="vrouw">vrouw</label>
        </div>
        <div class="form__radio-button">
          <input
              type="radio"
              id="neutraal"
              name="gender"
              value="neutraal"
              v-model="State.Klantengegevens.Contactpersoon.Geslacht"
          />
          <span></span>
          <label class="form__radio-button-label" for="neutraal">neutraal</label>
        </div>
      </div>
      <span class="error">{{ errors[0] }}</span>
    </ValidationProvider>
    <div class="form__row">
      <text-field
          input-id="voorletters"
          label="Voorletters"
          placeholder="A.B."
          rules="required"
          v-model="State.Klantengegevens.Contactpersoon.Voorletters"
      />

      <text-field
          input-id="tussenvoegsel"
          label="Tussenvoegsel"
          placeholder="van"
          v-model="State.Klantengegevens.Contactpersoon.Tussenvoegsel"
      />
    </div>

    <div class="form__row">
      <text-field
          input-id="achternaam"
          label="Achternaam"
          placeholder="Achternaam"
          rules="required"
          v-model="State.Klantengegevens.Contactpersoon.Achternaam"
      />
    </div>

<!--    <div class="form__row">-->
<!--      <text-field-->
<!--          input-id="contactpersoontelefoonnummer"-->

<!--          label="Telefoonnummer"-->
<!--          placeholder="0529123456"-->
<!--          rules="phone"-->
<!--          v-model="State.Klantengegevens.Contactpersoon.Telefoonnummer"-->
<!--      />-->
<!--    </div>-->
<!--    <div class="form__row">-->
<!--      <text-field-->
<!--          input-id="email"-->
<!--          label="E-mailadres"-->
<!--          placeholder="voorbeeld@mail.nl"-->
<!--          rules="required|email"-->
<!--          v-model="State.Klantengegevens.Contactpersoon.Emailadres"-->
<!--      />-->
<!--    </div>-->


    <h2 class="form__subtitle">Aansluitadres</h2>

    <div class="form__row">
      <text-field
          input-id="adres"
          label="Adres"
          placeholder="Dorpstraat"
          :value="State.street"
          rules="required"
          v-model="State.Klantengegevens.Adresgegevens.Adres"
      />
      <text-field
          input-id="huisnr"
          label="Huisnr"
          placeholder="1"
          :value="State.houseno"
          rules="required"
          v-model="State.Klantengegevens.Adresgegevens.Huisnr"
      />
      <text-field
          input-id="huisnr_toev"
          label="Toevoeging"
          placeholder="A"
          :value="State.houseno_ext"
          rules=""
          v-model="State.Klantengegevens.Adresgegevens.Huisnr_toev"
      />
    </div>

    <div class="form__row">
      <text-field
          input-id="postcode"
          label="Postcode"
          placeholder="0000 XX"
          :value="State.zipcode"
          rules="required|zipcode"
          v-model="State.Klantengegevens.Adresgegevens.Postcode"
      />
      <text-field
          input-id="plaats"
          label="Plaats"
          placeholder="Dalfsen"
          :value="State.city"
          rules="required"
          v-model="State.Klantengegevens.Adresgegevens.Plaats"
      />
    </div>

    <h2 class="form__subtitle">Factuuradres</h2>

    <div class="form__row">
      <text-field
          input-id="adres"
          label="Adres"
          placeholder="Dorpstraat"
          :value="State.street"
          rules="required"
          v-model="State.Klantengegevens.Factuuradres.Adres"
      />
      <text-field
          input-id="huisnr"
          label="Huisnr"
          placeholder="1"
          :value="State.houseno"
          rules="required"
          v-model="State.Klantengegevens.Factuuradres.Huisnr"
      />
      <text-field
          input-id="huisnr_toev"
          label="Toevoeging"
          placeholder="A"
          :value="State.houseno_ext"
          rules=""
          v-model="State.Klantengegevens.Factuuradres.Huisnr_toev"
      />
    </div>

    <div class="form__row">
      <text-field
          input-id="postcode"
          label="Postcode"
          placeholder="0000 XX"
          :value="State.zipcode"
          rules="required|zipcode"
          v-model="State.Klantengegevens.Factuuradres.Postcode"
      />
      <text-field
          input-id="plaats"
          label="Plaats"
          placeholder="Dalfsen"
          :value="State.city"
          rules="required"
          v-model="State.Klantengegevens.Factuuradres.Plaats"
      />
    </div>

    <h2 class="form__subtitle">Contactgegevens</h2>

    <div class="form__row">
      <text-field
          input-id="mobiel-nummer"
          class="form__text-field--60-width"
          label="Mobiel telefoonnummer"
          placeholder="0612345678"
          rules="required|mobilephone"
          v-model="State.Klantengegevens.Contactgegevens.MobielTelefoonnummer"
      />
    </div>
    <div class="form__row">
      <text-field
          input-id="vast-nummer"
          class="form__text-field--60-width"
          label="Vast telefoonnummer (indien nummerbehoud gewenst)"
          placeholder="0529123456"
          rules="phone"
          v-model="State.Klantengegevens.Contactgegevens.VastTelefoonnummer"
      />
    </div>
    <div class="form__row">
      <text-field
          input-id="email"
          label="E-mailadres"
          placeholder="voorbeeld@mail.nl"
          rules="required|email"
          v-model="State.Klantengegevens.Contactgegevens.Emailadres"
      />
    </div>
    <div class="form__row">
      <text-field
          input-id="emailfacturatie"
          label="E-mailadres facturatie"
          placeholder="voorbeeld@mail.nl"
          rules="email"
          v-model="State.Klantengegevens.Contactgegevens.FactuurEmail"
      />
    </div>
    <div v-if="providerEmailAdress === true" class="form__row">
      <text-field
          input-id="plinq-email"
          class="form__text-field--60-width"
          :label="'(Indien gewenst) Mijn '+companyName+' e-mailadres'"
          v-model="State.Klantengegevens.Contactgegevens.PLINQEmailadres"
      >
        <template v-slot:afterInput>
          <p class="form__text-field-details">@{{companyCustomerEmail}}</p>
        </template>
      </text-field>
    </div>

    <h2 class="form__subtitle">Betaalgegevens</h2>
    <p class="form__description">Je betaalt je abonnement maandelijks via automatisch incasso.</p>
    <div class="form__row">
      <text-field
          input-id="rekeningnummer"
          label="IBAN-rekeningnummer"
          placeholder="NL00BANK0123456789"
          rules="required|iban"
          v-model="State.Klantengegevens.Betaalgegevens.Rekeningnummer"
      />
    </div>

    <div class="form__row">
      <text-field
          input-id="achternaam"
          label="Naam rekeninghouder"
          placeholder="Achternaam"
          v-model="State.Klantengegevens.Betaalgegevens.NaamRekeninghouder"
          rules="required"
      />
      <text-field
          input-id="woonplaats"
          label="Woonplaats rekeninghouder"
          placeholder="Plaats"
          rules="required"
          v-model="State.Klantengegevens.Betaalgegevens.WoonplaatsRekeninghouder"
      />
    </div>


    <h2 class="form__subtitle">Overige</h2>

    <custom-textarea
        row
        id="opmerkingen"
        label="Eventuele opmerkingen"
        v-model="State.Klantengegevens.Overig.Opmerking"
    />

    <checkbox row id="voorwaarden" v-model="State.Klantengegevens.Overig.AlgemeneVoorwaarden" rules="is_true">
      Ik ga akkoord met de <a :href="termsUrl" target="_blank">algemene voorwaarden</a> van {{ companyName }} BV.
    </checkbox>
  </div>

  <!-- +++++++++++++++++++++++ END customer type zakelijk  ++++++++++++++++++++++++++++++ -->

</template>

<script>
import TextField from './form-components/text-field.vue'
import State from '../state.js'
import Checkbox from '@/components/form-components/checkbox.vue'
import CustomTextarea from './form-components/custom-textarea.vue'

export default {
  components: {
    Checkbox,
    TextField,
    CustomTextarea
  },
  data: function () {
    return { State }
  },
  computed: {
    termsUrl: function () {
      return process.env.VUE_APP_TERMS_AND_CONDITIONS_URL
    },
    companyName: function () {
      return process.env.VUE_APP_COMPANY_NAME
    },
    companyCustomerEmail: function () {
      return process.env.VUE_APP_CUSTOMER_EMAIL_EXT
    },
    providerEmailAdress: function () {
      return process.env.VUE_APP_CUSTOMER_EMAIL_ADDRESS
    },
    neighboursActionEnabled: function () {
      console.log("neighboursActionEnabled" + process.env.VUE_APP_NEIGHBOURS_ACTION)
      return process.env.VUE_APP_NEIGHBOURS_ACTION
    }
  },
  created: function () {
    State.Klantengegevens.Adresgegevens.Adres = State.street
    State.Klantengegevens.Adresgegevens.Huisnr = State.houseno
    State.Klantengegevens.Adresgegevens.Huisnr_toev = State.houseno_ext
    State.Klantengegevens.Adresgegevens.Postcode = State.zipcode
    State.Klantengegevens.Adresgegevens.Plaats = State.city

    if(State.Zoekgegevens.cust_type==='zakelijk') {
      State.Klantengegevens.Factuuradres.Adres = State.street
      State.Klantengegevens.Factuuradres.Huisnr = State.houseno
      State.Klantengegevens.Factuuradres.Huisnr_toev = State.houseno_ext
      State.Klantengegevens.Factuuradres.Postcode = State.zipcode
      State.Klantengegevens.Factuuradres.Plaats = State.city
    }
  }
}
</script>

<style lang="scss">
.form__description {
  font-size: 0.8em;
}

.form__checkbox {
  text-align: left;
  margin: 50px 20px 50px 0;

  label {
    font-size: 1.2em;
  }
}

.form__row {
  display: flex;

  & * {
    flex-grow: 1;
  }

  & .form__text-field:last-child {
    margin-right: 0;
  }
}

.form__date-field {
  @extend .form__text-field;

  input[type="date"] {
    font-family: "Montserrat", Sans-serif;
    color: $text-color;
    font-weight: 500;

    &:focus {
      border-color: color('check');
      outline: none;
    }
  }
}

.form__text-field-details {
  font-size: 1.2em;
  width: max-content;
  display: inline-block;
}

div.form__text-field--60-width input {
  width: 60%;
  display: inline-block;
}

div.form__text-field--20-width input {
  width: 20%;
  display: inline-block;
}

.form__text-field {
  display: inline-block;
  margin: 10px 10px 0 0;

  label {
    display: block;

    font-size: 1.2em;
  }

  input,
  textarea {
    resize: none;

    display: block;
    background-color: color(6);
    border: solid 1px $color-border;
    border-radius: 2px;

    font-size: 1.2em;

    padding: 10px;
    margin-top: 10px;

    width: calc(100% - 30px);

    color: $text-color;

    &::placeholder {
      color: $text-color;
    }

    &:focus {
      border-color: color(2);
      outline: none;
    }
  }
}

.form__button-submit {
  height: 100%;
  width: calc(100% - #{$block-margin} * 2);

  margin: $block-margin;
  padding: 30px 0 30px 0;

  background-color: color('submitbutton');

  font-size: 1.8em;
  font-weight: bold;

  &:hover {
    background-color: darken(color('submitbutton'), 10%);
  }
}

.form {
  font-weight: 500;
  text-align: left;
}

h1.form__title {
  text-align: left;
  margin-bottom: -40px;
  font-size: 3em;
}

.form__subtitle {
  color: color('form__subtitle');
  margin-top: 80px;
}

.form__input-title {
  font-size: 1.2em;
}

.form__radio-group {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  resize: none;
  font-size: 1.2em;
  width: calc(100% - 30px);
  color: #4d4d4d;
  border-radius: 2px;
}

.form__radio-group-invalid {
  border: solid 1px #ccc;
  border-radius: 2px;
}

@include mobile {
  .form__row {
    flex-direction: column;
  }

  div.form__text-field--60-width input {
    width: calc(100% - 30px);
  }

  .form__checkbox {
    display: flex;
    align-items: center;
  }
}

.invalid {
  border-color: red !important;
}

.error {
  display: block;
  margin-top: 0.5em;
  flex-basis: 100%;
  color: red !important;
}

.form__radio-button {
  display: flex;
  align-items: center;
}

.form__radio-button-label {
  margin: 0 5px;
}
</style>
